module.exports = __webpack_public_path__ + "01ea978f/img/settings-ico.a214628d.svg";